<div class="aside-backdrop" [class.show]="display()" (click)="closed.emit()" aria-hidden="true"></div>
<aside class="aside-menu" [class.show]="display()" [class.fixed]="fixed()">
  <ng-content></ng-content>
</aside>
